import { compact } from 'fp-ts/Array';
import { RequestParams } from '~/core/api/RequestTypes';
import { GeneralFilter } from '../features/filtering/GeneralFilter';
import { State } from '../state/types/state';

export interface GetUpdateRequestParamsParams {
    stateSets: State['sets'];
    stateControls: State['controls'];
    querySetIdentifier: string;
    from: number;
}

/**
 * Get request parameters for updating request
 * Triggered when user clicks on "Load more" button
 *
 * @returns request parameters
 */
const getUpdateRequestParams = ({
    stateSets,
    stateControls,
    querySetIdentifier,
    from,
}: GetUpdateRequestParamsParams): RequestParams => {
    const filter = new GeneralFilter();

    return stateSets
        .filter((set) => set.querySet.identifier === querySetIdentifier)
        .map((set) => {
            const querySetControls = stateControls.find(
                (controls) => controls.querySet.identifier === set.querySet.identifier
            );

            return {
                name: set.querySet.identifier,
                from: from,
                size: set.size,
                indices: querySetControls?.indices
                    ? querySetControls.indices.filter((index) => index.isChecked).map((index) => index.identifier)
                    : undefined,
                filters: querySetControls?.filters
                    ? compact(querySetControls.filters.map(filter.createRequestPayloadFromState))
                    : undefined,
                sort: querySetControls?.sorting ? querySetControls.sorting : null,
            };
        });
};

export default getUpdateRequestParams;
